export const GET_CONSULTANTS_FUNCTIONS = "get_consultants_function";
export const CREATE_CONSULTANT_FUNCTION = "create_consultant_function";
export const EDIT_CONSULTANT_FUNCTION = "edit_consultant_function";
export const START_LOADING = "start_loading";
export const DELETE_CONSULTANT_FUNCTION = "delete_consultant_function";
export const STOP_LOADING = "stop_loading";
export const ERROR = "error";
export const ACCESS_RIGHT_ERROR = "access_error";